import { Box, Button, Typography } from "@mui/material"
import dayjs from 'dayjs'
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useFetch } from "../../hook/useFetch"
import { rutas } from "../../rutas/rutas"
import { setInformacion } from "../../storage/slices/usuarios"
import utc from 'dayjs/plugin/utc'
import fondo from '../../Web Mundo/fondo.mp3'
import ReactHowler from 'react-howler'
import { getCookie } from "../../utils/getCookie"
import axios from "axios"
export const Cronometro = ({time, timeServer, tipo= "normal"}) => {
dayjs.extend(utc)
console.log(dayjs.utc().format())
const date1 = dayjs(time).utc()
const date2 = dayjs(new Date()).utc()
const [misionTiempo,setMisionTiempo] = useState(date1.diff(date2, 'seconds'))
const [reward, setReward] = useState('')
const [usuario, setUsuario] =  useState('')
const [horas, setHoras] = useState(0)
const [playing, setPlaying] = useState(false)
const dispatch = useDispatch()
const [tiempo, setTiempo] = useState(0)
const [peticion] = useFetch()
const [finalizo, setFinalizo] = useState(false)
const secondsToString = (seconds) => {
    let hour = Math.floor(seconds / 3600);
    hour = (hour < 10) ? '0' + hour : hour;
    let minute = Math.floor((seconds / 60) % 60);
    minute = (minute < 10)? '0' + minute : minute;
    let second = seconds % 60;
    second = (second < 10)? '0' + second : second;
    return hour + ':' + minute + ':' + second;
  }
  useEffect(()=>{
    const timeActual = secondsToString(misionTiempo)
    setTiempo(timeActual)
  },[])
  useEffect(()=>{
        if((misionTiempo <= 0 || tiempo === "00:00:00") &&  tipo === "normal"){
    const tokenJWT = getCookie('token')
   axios({
        method: 'post',
        url: rutas.finalizar,
        headers:  {
          'token': tokenJWT,
          'Content-Type': 'application/json'},
        data: {tipo}

 
          
        
    }).then(({data})=>{
    
      if(data?.reward){
        console.log(data.reward)
        setReward(data.reward)
        setUsuario(data.usuario)
        setPlaying(true)
        setTimeout(()=>setPlaying(false),1500 )
     
      }
     
     })


   }

  },[misionTiempo])
 
useEffect(()=>{
    if(misionTiempo > 0){    
        const intervarlo = setInterval(()=>{
          document.title = tiempo.substring(0,3) === "00:" ? tiempo.substring(3,tiempo?.length) : tiempo
            const timeActual = secondsToString(date1.diff(date2, 'seconds') -1)
          setTiempo(timeActual)
          setMisionTiempo(date1.diff(date2, 'seconds') -1)
          
        },1000)

        return () => clearInterval(intervarlo)
    }
},[tiempo])
const recolectar = ()=>{
  if(tipo === "especial" && !finalizo){
   if(misionTiempo <= 0 || tiempo === "00:00:00"){
    const tokenJWT = getCookie('token')

   axios({
        method: 'post',
        url: rutas.finalizar,
        headers:  {
          'token': tokenJWT,
          'Content-Type': 'application/json'},
        data: {tipo}

 
          
        
    }).then(({data})=>{
    
      if(data?.reward){
        console.log(data.reward)
        setReward(data.reward)
        setUsuario(data.usuario)
        setPlaying(true)
        setTimeout(()=>setPlaying(false),1500 )
       setFinalizo(true)
      }
     
     })


   }

  }
    
 if(usuario !== '' && tipo === "normal") dispatch(setInformacion(usuario));
}
  return (
    <>
       {
       misionTiempo > 0 ? <Typography sx={{textAlign: 'center'}}>
          Finish - {tiempo}
        </Typography>
        :  <Box>
        <Typography sx={{textAlign: 'center', display: 'inline', mr: 2}}>{reward}</Typography>
 
{      !finalizo ?  <Button variant="contained" onClick={recolectar} >collect</Button> : <Button variant="contained" onClick={()=> {
   if(usuario !== '' && tipo === "especial") dispatch(setInformacion(usuario));

}} >Close</Button> 
}     </Box>
  
        
      }
          {playing  &&  <ReactHowler loop={true} playing={playing} volume={0.2} src= {fondo}  /> }

    </>
  )
}
